import AppEvents from 'Shared/app-events';
import ds from 'Shared/ds';

export default class CompareApi {

    static #onChanged = (result) => {
        if (result.Success) {
            AppEvents.emit(this.Events.COMPARE_CHANGED, result);
        }
    }

    static addProduct = async (productId) => await ds
        .post(this.#const.ADD, {
            ProductId: productId
        })
        .done(this.#onChanged);

    static data = async () => await ds.get(this.#const.DATA);

    static remove = async () => await ds.post(this.#const.REMOVE)
            .done(this.#onChanged);

    static removeItem = async (itemId) => {

        var data = {
            Items: [itemId]
        };

        return await ds.post(this.#const.REMOVEITEM, data)
            .done(this.#onChanged);
    }

    static #const = {
        DATA: "/compare/data",
        ADD: "/compare/additem",
        REMOVE: "/compare/remove",
        REMOVEITEM: "/compare/removeitem"
    };

    static Events = {
        ADD: "compare.add",
        COMPARE_CHANGED: "compare-changed"
    };
}